import type { PlatformPolicyConfig } from '../../lib/types';
import { getStageWindows, type AdhikaraStageKey } from './weights';

export type AdhikaraStage = AdhikaraStageKey;

export interface StageMeta {
  stage: AdhikaraStage;
  label: string;
  meaning: string;
}

export function getStage(score: number | null | undefined, policy?: PlatformPolicyConfig | null): AdhikaraStage | null {
  if (!Number.isFinite(score as number)) return null;
  const windows = getStageWindows(policy);
  const value = Number(score);

  for (const key of ['BIJA', 'ANKURA', 'PARNA', 'PUSHPA', 'PHALA'] as const) {
    const [min, max] = windows[key].range;
    if (value >= min && value <= max) return key;
  }
  return null;
}

export function getStageMeta(score: number | null | undefined, policy?: PlatformPolicyConfig | null): StageMeta | null {
  const stage = getStage(score, policy);
  if (!stage) return null;
  const windows = getStageWindows(policy);
  return {
    stage,
    label: windows[stage].label,
    meaning: windows[stage].meaning,
  };
}
